import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bytesFormater' })
export class BytesFormaterPipe implements PipeTransform {
    transform(value: any): string {
        if (value >= 1e6) return (value / 1e6).toFixed(1) + ' Mbytes';
        if (value >= 1e3) return (value / 1e3).toFixed(1) + ' Kbytes';
        return value?.toString();
    }
}
